import { DraftReturnSchema } from "@redotech/redo-return-operations-common/draft-return/draft-return";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const MerchantItemFlowBatchExchange = {
  NONE: "none",
  SAME_ITEM: "same_item",
} as const;

export type MerchantItemFlowBatchExchange =
  (typeof MerchantItemFlowBatchExchange)[keyof typeof MerchantItemFlowBatchExchange];

export const addMerchantItemFlowBatch = {
  name: "addMerchantItemFlowBatch" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    items: z
      .array(
        z.object({
          returnableItemId: z.string(),
          previousPendingItemId: z.string().nullish(),
          exchange: z.enum([
            MerchantItemFlowBatchExchange.NONE,
            MerchantItemFlowBatchExchange.SAME_ITEM,
          ]),
        }),
      )
      .min(1),
    returnReasons: z.array(z.string()),
    returnReasonCodes: z.array(z.string().nullish()).optional(),
    notes: z.string().nullish(),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};

export type AddMerchantItemFlowBatchInput = z.infer<
  typeof addMerchantItemFlowBatch.input
>;
